import enCommon from './locales/en/common.json';
import enDashboard from './locales/en/dashboard.json';
import enSettings from './locales/en/settings.json';
import enAuth from './locales/en/auth.json';
import enChat from './locales/en/chat.json';
import enHomework from './locales/en/homework.json';
import enNotification from './locales/en/notification.json';
import enReport from './locales/en/report.json';
import enAnnouncement from './locales/en/announcement.json';
import enCalendar from './locales/en/calendar.json';

import arCommon from './locales/ar/common.json';
import arDashboard from './locales/ar/dashboard.json';
import arSettings from './locales/ar/settings.json';
import arAuth from './locales/ar/auth.json';
import arChat from './locales/ar/chat.json';
import arHomework from './locales/ar/homework.json';
import arNotification from './locales/ar/notification.json';
import arReport from './locales/ar/report.json';
import arAnnouncement from './locales/ar/announcement.json';
import arCalendar from './locales/ar/calendar.json';

import { flattenMessages } from './flatten-messages';

export type AppLocale = 'en' | 'ar';

export const DEFAULT_LOCALE: AppLocale = 'en';
export const LOCALE_STORAGE_KEY = 'tara-language';

export const localeConfig: Record<AppLocale, { direction: 'ltr' | 'rtl' }> = {
  en: { direction: 'ltr' },
  ar: { direction: 'rtl' }
};

export const messages: Record<AppLocale, Record<string, string>> = {
  en: {
    ...flattenMessages(enCommon),
    ...flattenMessages(enDashboard),
    ...flattenMessages(enSettings),
    ...flattenMessages(enAuth),
    ...flattenMessages(enChat),
    ...flattenMessages(enAnnouncement),
    ...flattenMessages(enReport),
    ...flattenMessages(enHomework),
    ...flattenMessages(enNotification),
    ...flattenMessages(enCalendar)
  },
  ar: {
    ...flattenMessages(arCommon),
    ...flattenMessages(arDashboard),
    ...flattenMessages(arSettings),
    ...flattenMessages(arAuth),
    ...flattenMessages(arChat),
    ...flattenMessages(arAnnouncement),
    ...flattenMessages(arReport),
    ...flattenMessages(arHomework),
    ...flattenMessages(arNotification),
    ...flattenMessages(arCalendar)
  }
};
